export const appBaseURL = "/rechner/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width,initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Stellen Sie jetzt eine Anfrage und erhalten Sie Ihr persönliches, auf Ihr Haus zugeschnittenes Angebot! ► Jetzt Stromerzeuger werden!"},{"name":"theme-color","content":"rgb(253,233,192)"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/fav/ms-icon-144x144.png"}],"link":[{"rel":"apple-touch-icon","sizes":"57x57","href":"/fav/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/fav/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/fav/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/fav/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/fav/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/fav/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/fav/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/fav/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/fav/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/fav/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/fav/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/fav/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/fav/favicon-16x16.png"},{"rel":"manifest","href":"/fav/manifest.json"}],"style":[],"script":[],"noscript":[],"viewport":"width=device-width,initial-scale=1","title":"Solarrechner - Der Solarteur: Solar- und PV Anlagen in Dortmund"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000